jQuery(($) => {
    $.fn.getSelectedFilters = function () {
        var items   = $(this).find('.m-filter-cat-item--is-active'),
            filters = {};

        items.each(function () {
            var activeTax  = $(this).data('taxonomy'),
                activeTerm = $(this).data('term');

            filters[activeTax] = filters[activeTax] || [];
            filters[activeTax].push(activeTerm);
        });

        return filters;
    }


    $.fn.getPage = function () {
        var page = parseInt($('.o-staff-feed__main').data('page')) || 1;

        if ($(this).hasClass('next page-numbers')) {
            page++;
        } else if ($(this).hasClass('prev page-numbers')) {
            page--;
        } else if ($(this).hasClass('page-numbers')) {
            page = parseInt($(this).text());
        }

        return page;
    };


    if ($('.o-staff-feed')[0]) {
        function fetch_staff_posts(page) {
            var activeFilters = $('.m-post-filter__list').getSelectedFilters(),
                postType      = $('.o-staff-feed').data('post-type');

            $('.o-staff-feed__main').addClass('o-staff-feed__main--loading');
            $('.o-staff-feed__sidebar').addClass('o-staff-feed__sidebar--loading');
            $('.o-staff-feed__modal').addClass('o-staff-feed__modal--loading');

            $.ajax({
                type: 'POST',
                url: AJAX.url,
                data: {
                    action: 'load_filtered_posts',
                    active_filters: activeFilters,
                    page: page,
                    post_type: postType
                },
                dataType: 'json',
                beforeSend: function () {
                    AjaxRunning++;
                },
                success: function (result) {
                    if (result.data.feed) {
                        $('.o-staff-feed').html(result.data.feed);
                        $('.o-staff-feed').find('.o-staff-feed__main').removeClass('o-staff-feed__main--loading');
                        $('.o-staff-feed').find('.o-staff-feed__sidebar').removeClass('o-staff-feed__sidebar--loading');
                        $('.o-staff-feed__modal').removeClass('o-staff-feed__modal--loading');
                    } 

                    if (result.data.filters) {
                        // $('.m-post-filter__list').replaceWith(result.data.filters);

                        // $('.m-post-filter__list').each(function(){
                        //     $(this).replaceWith(result.data.filters);
                        // })

                        $('.m-posts-feed-sidebar').each(function () {
                            $(this).replaceWith(result.data.filters);
                        })
                    }

                    if (result.data.url) {
                        window.history.pushState({
                            feed: result.data.feed,
                            filters: result.data.filters,
                        }, {}, result.data.url);
                    }

                    $('html,body').animate({
                        scrollTop: $('#staff-feed').offset().top - 120
                    });

                    $(window).trigger('ajax');

                    $('.m-modal').modal();
                    $('.m-modal-trigger').modal_trigger();

                    $('o-staff-feed__posts-feed-sidebar').removeClass('o-staff-feed__posts-feed-sidebar--open');
                },
                complete: function () {
                    AjaxRunning--;
                } 
            });
        }


        if ($('.o-staff-feed')[0]){
            var AjaxRunning = 0;

            $(window).on('load ajax', function () {
                $('.js-clear-all-filters').click(function (e) {
                    e.preventDefault();

                    $('.m-selected-filter-cat-items').remove();

                    $('.m-filter-cat-item').removeClass('m-filter-cat-item--is-active');

                    fetch_staff_posts();
                });

                $('.m-selected-filter-cat-items__button').click(function (e) {
                    e.preventDefault();

                    var taxonomy   = $(this).parent().data('taxonomy'),
                        term       = $(this).parent().data('term'),
                        activeTerm = $(".m-filter-cat-item[data-taxonomy='" + taxonomy + "'][data-term='" + term + "']")

                    $(this).parent().remove();

                    if (($('.m-selected-filter-cat-items__item').length == 0)) {
                        $('.m-selected-filter-cat-items').remove();
                    }

                    activeTerm.addClass('okeyyy');
                    activeTerm.removeClass('m-filter-cat-item--is-active');

                    fetch_staff_posts();
                });

                $('.m-filter-cat-item__button').click(function (e) {
                    e.preventDefault();

                    if (!AjaxRunning) {
                        // Set load classes
                        $(this).parent().toggleClass('m-filter-cat-item--is-active');

                        // Get staff posts
                        fetch_staff_posts();
                    } 
                });

                $('.m-pagination .page-numbers').click(function (e) {
                    e.preventDefault();

                    var page = $(this).getPage();

                    fetch_staff_posts(page);
                });
            });

            $(window).on('popstate', function (e) {
                if (e.originalEvent.state !== null) {
                    if (e.originalEvent.state.feed) {
                        $('.o-staff-feed').html(e.originalEvent.state.feed);
                    }

                    if (e.originalEvent.state.filters) {
                        $('.m-post-filter__list').replaceWith(e.originalEvent.state.filters);
                    }
                }
            });
        }
    }

    $(window).on('load ajax', function(){
        $('#o-staff-feed__filter-modal_trigger').click(function () {
            $('.o-staff-feed__sidebar').addClass('o-staff-feed__sidebar--open');
        });

        $('.o-staff-feed__mobile-trigger-close').click(function(){
            if ($('.o-staff-feed__sidebar').hasClass('o-staff-feed__sidebar--open')){
                $('.o-staff-feed__sidebar').removeClass('o-staff-feed__sidebar--open');
            }
        })
    });
});